export default __webpack_public_path__ + "static/media/bell.d8feef1f.wav";